import { Grid2, Typography } from "@mui/material";

export default function GraphContainer({ header, children }) {
  return (
    <Grid2
      size={{
        xs: 12,
        sm: 6,
        md: 6,
        lg: 4,
        xl: 4,
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
        height: 300,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
        }}
      >
        {header}
      </Typography>
      {children}
    </Grid2>
  );
}
